import { render, staticRenderFns } from "./pwa-install-dialog-actions-ios.vue?vue&type=template&id=03aff09a&"
import script from "./pwa-install-dialog-actions-ios.vue?vue&type=script&lang=js&"
export * from "./pwa-install-dialog-actions-ios.vue?vue&type=script&lang=js&"
import style0 from "./pwa-install-dialog-actions-ios.vue?vue&type=style&index=0&id=03aff09a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports